import React, {useEffect, useState, useRef} from 'react';
import FileUpload from "../../FileUploads/FileUpload";
import SearchLocation from "../../searchLocation/searchLocation";

const Strategic = ({
                       documentUploadUrlPublic,
                       documentUrlDataPublic,
                       getCityStateByPincode,
                       pincodeData = [],
                       dropdownValue,
                       handleInput,
                       locationCity = [],
                       locationZone,
                       locationArea,
                       zones = [],
                       areas = [],
                       siteImages,
                       handleAddSiteImages,
                       removeSiteImages,
                       handleSiteImagesInput,
                       accountDetailsByIdData,
                       isEdit = false,
                       inputList,
                       setSiteImages,
                       isView = false
                   }) => {

    const [leadSource, setLeadSource] = useState('');
    const [clientTypeId, setClientTypeId] = useState(0)
    const [cityId, setCityId] = useState(0)
    const [zoneId, setZoneId] = useState(0)
    const [areaId, setAreaId] = useState(0)
    const [pincodeValue, setPincodeValue] = useState('')
    const [lat, setLat] = useState('')
    const [long, setLong] = useState('')
    const ref = useRef(null);
    const [click, setClick] = useState('')

    useEffect(() => {
        if (click !== '' && !isView) {
            ref.current.click();
        }
    }, [click])

    useEffect(() => {
        getCityStateByPincode(pincodeValue)
    }, [pincodeValue])

    useEffect(() => {
        handleInput(clientTypeId, 'client_type_id')
    }, [clientTypeId])

    useEffect(() => {
        handleInput(leadSource, 'lead_source_id')
    }, [leadSource])

    useEffect(() => {
        (async () => {
            handleInput(cityId, 'city_id')
            await locationZone(cityId !== 0 ? cityId : accountDetailsByIdData?.city_id)
        })()
    }, [cityId])

    useEffect(() => {
        (async () => {
            handleInput(zoneId, 'zone_id')
            await locationArea(zoneId !== 0 ? zoneId : accountDetailsByIdData?.zone_id)
        })()
    }, [zoneId])

    useEffect(() => {
        handleInput(areaId, 'area_id')
    }, [areaId])

    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });

    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
            setLong(latlng?.lng)
            setLat(latlng?.lat)
            handleInput(latlng?.lng, 'longitude')
            handleInput(latlng?.lat, 'latitude')
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({...optOption, currentLocation: value});
        handleInput(value, 'current_location')
        if(!isEdit){
            handleInput(value, 'address_1')
        }
    };

    const [isInputError, setIsInputError] = useState({
        latError: false,
        longError: false,
        pinError: false,
        crl: false,
        isPinNotFound: false,
    });

    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            if (accountDetailsByIdData?.client_type_id !== undefined &&
                accountDetailsByIdData?.client_type_id !== null &&
                accountDetailsByIdData?.client_type_id !== '') {
                setClientTypeId(accountDetailsByIdData?.client_type_id)
            }

            if (accountDetailsByIdData?.current_location !== undefined &&
                accountDetailsByIdData?.current_location !== null &&
                accountDetailsByIdData?.current_location !== '') {
                setOptOption({...optOption, currentLocation: accountDetailsByIdData?.current_location});
            }

            if (accountDetailsByIdData?.latitude !== undefined &&
                accountDetailsByIdData?.latitude !== null &&
                accountDetailsByIdData?.latitude !== '') {
                setLat(accountDetailsByIdData?.latitude)
            }

            if (accountDetailsByIdData?.longitude !== undefined &&
                accountDetailsByIdData?.longitude !== null &&
                accountDetailsByIdData?.longitude !== '') {
                setLong(accountDetailsByIdData?.longitude)
            }

            handleInput(accountDetailsByIdData?.client_name, 'client_name')
            handleInput(accountDetailsByIdData?.lead_source_id, 'lead_source_id')
            handleInput(accountDetailsByIdData?.building_name, 'building_name')
            handleInput(accountDetailsByIdData?.client_type_id, 'client_type_id')
            handleInput(accountDetailsByIdData?.sale_team_name, 'sale_team_name')
            handleInput(accountDetailsByIdData?.name_of_referrer, 'name_of_referrer')
            handleInput(accountDetailsByIdData?.first_contact_date, 'first_contact_date')
            handleInput(accountDetailsByIdData?.building_managed, 'building_managed')
            handleInput(accountDetailsByIdData?.gate_managed, 'gate_managed')
            handleInput(accountDetailsByIdData?.parking_slot_managed, 'parking_slot_managed')
            handleInput(accountDetailsByIdData?.city_id, 'city_id')
            handleInput(accountDetailsByIdData?.zone_id, 'zone_id')
            handleInput(accountDetailsByIdData?.area_id, 'area_id')
            handleInput(accountDetailsByIdData?.address_1, 'address_1')
            handleInput(accountDetailsByIdData?.address_2, 'address_2')
            handleInput(accountDetailsByIdData?.pincode, 'pincode')
            setPincodeValue(accountDetailsByIdData?.pincode)
            handleInput(pincodeData?.geographical_city_id, 'geographical_city_id')
            handleInput(pincodeData?.geographical_state_id, 'geographical_state_id')
            handleInput(accountDetailsByIdData?.latitude, 'latitude')
            handleInput(accountDetailsByIdData?.longitude, 'longitude')
            handleInput(accountDetailsByIdData?.site_images, 'site_image')
        }

    }, [accountDetailsByIdData])

    useEffect(() => {
        if (accountDetailsByIdData?.site_images !== undefined) {
            const tempArray = JSON.parse(JSON.stringify(accountDetailsByIdData?.site_images)) ?? []; // deep copy
            let len = tempArray.length
            for (let i = 0; i < len; i++) {
                setClick(i)
            }
        }
    }, [accountDetailsByIdData?.site_images])

    useEffect(() => {
        if (accountDetailsByIdData?.site_images !== undefined) {
            const tempArray = JSON.parse(JSON.stringify(accountDetailsByIdData?.site_images)) ?? []; // deep copy
            let len = tempArray.length
            delete siteImages[0]['url']
            console.log("siteImagessiteImagessiteImages "+JSON.stringify(siteImages))
            for (let i = 0; i < len; i++) {
                if (i === 0) {
                    siteImages[0]['url'] = tempArray[i]['url']
                } else {
                    siteImages.push({url: tempArray[i]['url']})
                }
            }

            setSiteImages(tempArray)
        }
    }, [accountDetailsByIdData?.site_images, click])

    return (
        <>
            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Account Details</h1>
                </div>
                <div className="card-body  bg-white">
                    <div className="user">
                        <div className="form-group row">
                            <div className="col-sm-6 float-field mt-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'client_name')
                                       }}
                                       required
                                       value={inputList[0]?.client_name}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Business Name <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mt-1">
                                <select className="form-control form-control-user" onChange={(e) => {
                                    setClientTypeId(e.target.value)
                                }} required disabled={isView} style={isView ? {backgroundImage: "none"} : {}}>
                                    <option value="">Select Client Type</option>
                                    {dropdownValue?.client_type!== undefined && dropdownValue && dropdownValue?.client_type.map((val) => {
                                        return (
                                            <>
                                                {(accountDetailsByIdData?.client_type_id === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Client Type <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-1">
                                <select className="form-control form-control-user" onChange={(e) => {
                                    setLeadSource(e.target.value)
                                }} required disabled={isView} style={isView ? {backgroundImage: "none"} : {}}>
                                    <option value="">Select Account Source</option>
                                    {dropdownValue?.corporate_lead_source!== undefined && dropdownValue?.corporate_lead_source.map((val) => {
                                        return (
                                            <>
                                                {(accountDetailsByIdData?.lead_source_id === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                    required
                                </select>
                                <label className="large-label float-lb">
                                    Account Source <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {(parseInt(accountDetailsByIdData?.lead_source_id) === 24 || parseInt(leadSource) ===24) &&
                                <div className="col-md-6 float-field mt-sel">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        handleInput(e.target.value, 'sale_team_name')
                                    }} required >
                                        <option value="">Source of acquisition</option>
                                        {accountDetailsByIdData?.sale_team_name === "Indiamart" ?
                                            <>
                                                <option value="Indiamart" selected>Indiamart</option>
                                                <option value="Just Dial">Just Dial</option>
                                                <option value=" Park+ online leads "> Park+ online leads</option>
                                                <option value="Referral">Referral</option>
                                            </>
                                            : accountDetailsByIdData?.sale_team_name === "Just Dial" ?
                                                <>
                                                    <option value="Indiamart">Indiamart</option>
                                                    <option value="Just Dial" selected>Just Dial</option>
                                                    <option value=" Park+ online leads "> Park+ online leads</option>
                                                    <option value="Referral">Referral</option>
                                                </> :
                                                accountDetailsByIdData?.sale_team_name === "Park+ online leads" ?
                                                    <>
                                                        <option value="Indiamart">Indiamart</option>
                                                        <option value="Just Dial">Just Dial</option>
                                                        <option value="Park+ online leads" selected> Park+ online leads
                                                        </option>
                                                        <option value="Referral">Referral</option>
                                                    </> :
                                                    accountDetailsByIdData?.sale_team_name === "Referral" ?
                                                        <>
                                                            <option value="Indiamart">Indiamart</option>
                                                            <option value="Just Dial">Just Dial</option>
                                                            <option value="Park+ online leads"  > Park+ online
                                                                leads
                                                            </option>
                                                            <option value="Referral" selected>Referral</option>
                                                        </>
                                                        :
                                                        <>
                                                            <option value="Indiamart">Indiamart</option>
                                                            <option value="Just Dial">Just Dial</option>
                                                            <option value="Park+ online leads"> Park+ online leads</option>
                                                            <option value="Referral">Referral</option>
                                                        </>
                                                }

                                    </select>
                                    <label className="large-label float-lb">
                                        Source of acquisition <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            {(parseInt(accountDetailsByIdData?.lead_source_id) === 19 || parseInt(leadSource) === 19) &&
                                <div className="col-sm-6 float-field mt-1">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'name_of_referrer')
                                           }}
                                           required
                                           value={inputList[0]?.name_of_referrer}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Name Of Referrer <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            <div className="col-sm-6 float-field mtk-05 d-mtk-03">
                                <input type="date"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'first_contact_date')
                                       }}
                                       required
                                       value={inputList[0]?.first_contact_date}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    First Contact Date <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field">
                                <input type="number"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'building_managed')
                                       }}
                                       value={inputList[0]?.building_managed}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Buildings Managed
                                </label>
                            </div>
                            {isView && inputList[0]?.gate_managed !== '' && inputList[0]?.gate_managed !== null &&
                                <div className="col-sm-6 float-field">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'gate_managed')
                                           }}
                                           value={inputList[0]?.gate_managed}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Gates managed
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'gate_managed')
                                           }}
                                           value={inputList[0]?.gate_managed}
                                    />
                                    <label className="large-label float-lb">
                                        Gates managed
                                    </label>
                                </div>
                            }
                            {isView && inputList[0]?.parking_slot_managed !== null && inputList[0]?.parking_slot_managed !== '' &&
                                <div className="col-sm-6 float-field">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'parking_slot_managed')
                                           }}
                                           value={inputList[0]?.parking_slot_managed}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Parking Slots Managed
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-sm-6 float-field">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'parking_slot_managed')
                                           }}
                                           value={inputList[0]?.parking_slot_managed}
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Parking Slots Managed
                                    </label>
                                </div>
                            }
                            {siteImages.map((val, i) => {
                                return (
                                    <>
                                        {!isView &&
                                            <div className="col-sm-6 mt-2 d-mtk-1">
                                                <FileUpload
                                                    id={"addAttachment" + i}
                                                    accept=".pdf,.png,.jpg,.jpeg,.doc"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => {
                                                        handleSiteImagesInput(i, val)
                                                    }}
                                                    prefilledFilename={val?.url !== '' && val?.url !== null ? "Uploaded Image" : ''}
                                                >
                                                    Site Image
                                                </FileUpload>
                                            </div>
                                        }

                                        <div className="col-sm-6 mt-2">
                                            <img src={val?.url}/>
                                        </div>
                                        {!isView &&
                                            <div className="btn-box mb-4"
                                                 style={{"width": "100%", "marginTop": "10%"}}>
                                                {siteImages.length !== 1 &&
                                                    <>
                                                        <button
                                                            onClick={(e) => removeSiteImages(e, i)}
                                                            className="btn btn-sm btn-danger ml-3 btn-ar">Remove
                                                        </button>
                                                    </>
                                                }
                                                {siteImages.length - 1 === i &&
                                                    <button
                                                        className="btn btn-sm btn-primary ml-3 btn-ar" ref={ref}
                                                        onClick={() => handleAddSiteImages()}>Add More
                                                    </button>}
                                            </div>
                                        }
                                    </>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Location Details</h1>
                </div>
                <div className="card-body  bg-white">
                    <div className="user">
                        <div className="form-group row">
                            <SearchLocation
                                handleCurrentLocationBlur={handleCurrentLocationBlur}
                                isError={isInputError.crl}
                                value={optOption.currentLocation}
                                handleCurrentLocationChange={handleCurrentLocationChange}
                                isView={isView}
                                setPincodeValue={setPincodeValue}
                            />
                            <div className="col-sm-6 float-field d-mtk-03">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(val) => {
                                           handleInput(val, 'latitude')
                                       }}
                                       value={lat}
                                       required
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Latitude <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(val) => {
                                           handleInput(val, 'longitude')
                                       }}
                                       value={long}
                                       required
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Longitude <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'address_1')
                                       }}
                                       required
                                       value={inputList[0]?.address_1}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Address of site 1 <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           setPincodeValue(e.target.value, 'pincode')
                                       }}
                                       value={pincodeValue}
                                       required
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Pincode <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(pincodeData?.geo_city_id, 'geographical_city_id')
                                       }}
                                       disabled
                                       value={pincodeData?.city_name !== undefined ? pincodeData?.city_name : ''}
                                       required
                                />
                                <label className="large-label float-lb">
                                    Geographical City <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(pincodeData?.geo_state_id, 'geographical_state_id')
                                       }}
                                       disabled
                                       value={pincodeData?.state_name !== undefined ? pincodeData?.state_name : ''}
                                       required
                                />
                                <label className="large-label float-lb">
                                    Geographical State <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-025">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setCityId(e.target.value)} required disabled={isView}
                                        style={isView ? {backgroundImage: "none"} : {}}>
                                    <option value="">Select City</option>
                                    {locationCity.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.city_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    City <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-075">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setZoneId(e.target.value)} required disabled={isView}
                                        style={isView ? {backgroundImage: "none"} : {}}>
                                    <option value="">Select Zone</option>
                                    {zones.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.zone_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Zone <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-sm-6 float-field mtk-075">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setAreaId(e.target.value)} required disabled={isView}
                                        style={isView ? {backgroundImage: "none"} : {}}>
                                    <option value="">Select Area/Sector</option>
                                    {areas.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.area_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                </select>
                                <label className="large-label float-lb">
                                    Area/Sector <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {/*<div className="col-sm-6 float-field">*/}
                            {/*    <input type="text"*/}
                            {/*           className="form-control form-control-user"*/}
                            {/*           placeholder=" "*/}
                            {/*           onChange={(e) => {*/}
                            {/*               handleInput(e.target.value, 'address_2')*/}
                            {/*           }}*/}
                            {/*           value={inputList[0]?.address_2}*/}
                            {/*    />*/}
                            {/*    <label className="large-label float-lb">*/}
                            {/*        Address of site 2*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                </div>
            </div>
            {/*<div className="col-md-12">*/}
            {/*    <div*/}
            {/*        className="d-sm-flex align-items-center justify-content-between com-sub-heading">*/}
            {/*        <h1 className="h3 mb-0 text-black-100">Others</h1>*/}
            {/*    </div>*/}
            {/*    <div className="card-body  bg-white">*/}
            {/*        <div className="user">*/}
            {/*            <div className="form-group row">*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    );
}
export default Strategic;